import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Breadcrumbs/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/CKEditorContent/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Icons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NextLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/src/components/Toastify/index.tsx");
